import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.01 7.517a2.435 2.435 0 0 0-3.416 0 2.36 2.36 0 0 0 0 3.363 2.435 2.435 0 0 0 3.417 0 2.36 2.36 0 0 0 0-3.363m-4.4-.994a3.835 3.835 0 0 1 5.386 0 3.76 3.76 0 0 1 0 5.352 3.835 3.835 0 0 1-5.387 0 3.76 3.76 0 0 1 0-5.352m8.49 2.956a.7.7 0 0 1 .7-.7h6.5a.7.7 0 0 1 .7.7v2.801a.7.7 0 0 1-.7.7h-6.499a.7.7 0 0 1-.7-.7zm1.4.7v1.401h5.1v-1.4zm-1.4 4.79a.7.7 0 0 1 .7-.7h4.482a.7.7 0 0 1 .7.7v2.801a.7.7 0 0 1-.7.7H14.8a.7.7 0 0 1-.7-.7zm1.4.7v1.401h3.082v-1.4zm-10.311 0c-.995 0-1.79.797-1.79 1.765v.448a.7.7 0 1 1-1.4 0v-.448c0-1.754 1.435-3.165 3.19-3.165h6.225a.7.7 0 1 1 0 1.4z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ResourceManagementIcon24.js.map